import React from 'react'
import styled from "styled-components";

const Input = styled.input`
  padding: 15px 13px;
  background: #fff;
  border: 1px solid ${props => props.error ? '#FC766A' : '#E9E9E9'};
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-shadow: 0 4px 32px 0 #00000012;
  font-size: 15px;
  font-weight: 400;
`

const ErrorMessage = styled.div`
  color: #FC766A;
  font-size: 13px;
  margin-top: 10px;
  font-family: "Roboto", sans-serif;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const TextInput = ({value, onChange, placeholder, error, validationError}) => {
    const errorMessage = validationError ? "Field value is not valid" : "This field is required"
    const handleInput = (e) => {
        onChange(e.target.value)
    }
    return (
        <InputWrapper>
            <Input placeholder={placeholder} value={value} onInput={(e) => handleInput(e)} error={error}/>
            {(error || validationError) && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </InputWrapper>
    )
}

export default TextInput;
